import React, { FC } from 'react';
import {Socket} from 'socket.io-client';

interface SocketContextProps {
  socket: Socket | null;
}

const SocketContext = React.createContext<SocketContextProps>({
  socket: null,
});

export default SocketContext;